<template>
	<div>
		<preloader-view v-if="isLoadingInitial"></preloader-view>

		<div v-else>
			<div class="styled-form__header white-box o-v-rhythm--small text--center" v-if="showedHeader && !regoOnborading">

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="skipErrors.global" :value="skipErrors.global"></global-message>

				<div v-if="showedHeader === 'newCustomer'">
					<h2 class="styled-form__title bottom-gap-xs">Welcome to your Football Account</h2>
					<h3 class="styled-form__subtitle bottom-gap-md">Connect with your favourite teams below to receive insider news and exclusive offers.</h3>
					<a class="styled-form__link" @click.prevent="skipHandler" v-if="!regoOnborading">Skip for now</a>
				</div>
				<div v-else-if="showedHeader === 'existingCompleted'">
					<h2 class="styled-form__title bottom-gap-xs">Update preferences</h2>
					<h3 class="styled-form__subtitle bottom-gap-md">Please update your account by reviewing your existing preferences.</h3>
				</div>
				<div v-else-if="showedHeader === 'existingNotCompleted'">
					<h2 class="styled-form__title bottom-gap-xs">Welcome back!</h2>
					<h3 class="styled-form__subtitle bottom-gap-md">You can update your account by updating your preferences below.</h3>
				</div>
			</div>

			<div
				:class="[
					'white-box',
					'o-v-rhythm',
					'styled-form',
					{'is-loading': isLoading}
				]"
			>

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="errors.global" :value="errors.global"></global-message>
				<div v-if="regoOnborading" class="styled-form__title bottom-gap-xs text--center form-group-title">Last step, setup preferences</div>

				<div v-show="hasUsername" :class="[
					'tiles-form-group',
					{'is-disabled': priorityTicketingCheckbox.heading.isDisabled}
				]">
					<h2 class="common__heading bottom-gap-lg">Priority Ticketing & Exclusive Offers</h2>

					<checkbox
						:checkbox="priorityTicketingCheckbox.checkboxes[0]"
						class="bottom-gap-15"
						@click.native="checkboxClickHandler('priorityTicketing', 0)"
					></checkbox>
				</div>

        <tiles-form-group
					:checkboxes="leagueGroup.checkboxes"
					:groupheading="leagueGroup.heading"
					header="Fan Communications"
					group-name="leagueGroup"
					:clickHandler="checkboxClickHandler"
					v-show="hasUsername"
				></tiles-form-group>

        <tiles-form-group
            :checkboxes="grassrootsGroup.checkboxes"
            :groupheading="grassrootsGroup.heading"
            header="Grassroots"
            group-name="grassrootsGroup"
            :clickHandler="checkboxClickHandler"
        ></tiles-form-group>

				<div v-show="hasUsername" :class="[
					'tiles-form-group',
					{'is-disabled': priorityTicketingCheckbox.heading.isDisabled}
				]">
                    <h2 class="common__heading bottom-gap-lg">Marketing Offers & Communications</h2>

                    <checkboxes-form-group
                        :checkboxes="checkboxGroup.checkboxes"
                        :groupheading="checkboxGroup.heading"
                        group-name="checkboxGroup"
                        :clickHandler="checkboxClickHandler"
                    ></checkboxes-form-group>
                </div>

        <div v-show="hasUsername" :class="[
            'tiles-form-group',
            {'is-disabled': disableCommunicationGroup.heading.isDisabled}
            ]"
        >
          <h2 class="common__heading bottom-gap-lg">Communications</h2>

          <checkboxes-form-group
              :checkboxes="disableCommunicationGroup.checkboxes"
              :groupheading="disableCommunicationGroup.heading"
              group-name="disableCommunicationGroup"
              :clickHandler="checkboxClickHandler"
          ></checkboxes-form-group>
        </div>

        <!-- <div v-show="hasUsername" :class="[
            'tiles-form-group',
            {'is-disabled': deletePreferences.heading.isDisabled}
            ]"
        >
          <h2 class="common__heading bottom-gap-lg">Remove All Preferences Data</h2>

          <checkboxes-form-group
              :checkboxes="deletePreferences.checkboxes"
              :groupheading="deletePreferences.heading"
              group-name="deletePreferences"
              :clickHandler="checkboxClickHandler"
          ></checkboxes-form-group>
        </div> -->

				<div class="text--center">
 					<button
						class="btn btn--secondary"
						:disabled="isLoading"
						v-if="showedHeader != 'newCustomer'"
						@click.prevent="onCancel"
						v-show="!regoOnborading"
					>Cancel</button>
					<button
						type="button"
						:class="['btn gtm-' + (offersPath() ? 'offer-' : 'preference-') + showSaveButton.toLowerCase().replace(/[\s\/]/g, '')]"
						@click.prevent="onSubmit"
					>{{ showSaveButton }}</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { cloneDeep } from 'lodash';
	import { mapState, mapGetters } from 'vuex';
	import PreloaderView from '../views/PreloaderView.vue';
	import TilesFormGroup from '../formGroups/TilesFormGroup.vue';
	import OfferFormGroup from '../formGroups/OfferFormGroup.vue';
	import CheckboxesFormGroup from '../formGroups/CheckboxesFormGroup.vue';
	import DisableCommunicationsGroup from '../formGroups/DisableCommunicationsGroup.vue';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import Checkbox from '../formFields/Checkbox.vue';
	import SlideDown from '../animations/SlideDown.vue';
	import api from "../../api";

	export default {
    components: {
      GlobalMessage,
      PreloaderView,
      TilesFormGroup,
      CheckboxesFormGroup,
      DisableCommunicationsGroup,
      Checkbox,
      SlideDown,
      OfferFormGroup
    },
    props: {
      user: {
        type: Object
      }
    },
    data() {
      return {
        destroyData: true,
        stateCopy: null,
        isLoadingInitial: false,
        isLoading: false,
        errors: {},
        skipErrors: {},
        hasOffers: false,
        hasUsername: false,
        showWwcbidOptin: false,
        regoOnborading: false,
        showInfoBox: false,
      }
    },
    mounted() {
      api.bangeo.getOffersByUser().then(result => {
        let offers = result.data.offers;
        if (offers.length > 0) {
          this.offerGroup.checkboxes = [];
          for (let i = 0; i < offers.length; i++) {

            let isChecked = false;
            let isDisabled = false;
            let offerType = "";

            if (offers[i]['cognito_id'] !== null) {
              isChecked = true;
              isDisabled = true;

              if (offers[i]['offer_id'] == 1) {
                offerType = "rebel";
              }
            }
            this.offerGroup.checkboxes.push({
              id: offers[i]['offer_id'],
              title: offers[i]['title'],
              description: offers[i]['description'],
              isChecked: isChecked,
              isDisabled: isDisabled,
              img: offers[i]['image_url'],
              cognito_id: offers[i]['cognito_id'],
              url: offers[i]['url'],
              type: offerType
            });
          }
          this.hasOffers = true;
          this.showWwcbidOptin = false;
        } else {
          this.hasOffers = false;
          this.showWwcbidOptin = false;
        }
      }).catch(error => {
        // console.log("getOffersByUser error", error);
      });

      this.refreshWwcbidOptin();
      if (this.user && this.user.username) this.hasUsername = true;

      if (localStorage.regoInProgress) this.regoOnborading = true;

      this.toggleInfoBox();
    },
    computed: {
      ...mapGetters('onboarding', [
        'clubGroupChecked',
        'leagueGroupChecked',
        'priorityTicketingIsChecked',
        'checkboxGroupChecked',
        'grassrootsGroupChecked',
        'disableGroupChecked',
        'offerGroupChecked',
        'optinGroupChecked'
      ]),
      ...mapState('onboarding', {
        onboardingState: state => state,
        form: state => state.form || {},
        clubGroup: state => state.formGroups.clubGroup,
        grassrootsGroup: state => state.formGroups.grassrootsGroup,
        leagueGroup: state => state.formGroups.leagueGroup,
        priorityTicketingCheckbox: state => state.formGroups.priorityTicketing,
        checkboxGroup: state => state.formGroups.checkboxGroup,
        disableCommunicationGroup: state => state.formGroups.disableCommunicationGroup,
        // deletePreferences: state => state.formGroups.deletePreferences,
        disableGroup: state => state.formGroups.disableGroup,
        offerGroup: state => state.formGroups.offerGroup,
        optinGroup: state => state.formGroups.optinGroup
      }),
      showedHeader() {
        /*
				* newCustomer
				* existingCompleted
				* existingNotCompleted
				* */
        let result = false;
        if (this.form) {
          switch (this.form.onboarding) {
            case 'New':
              switch (this.form.onboardingcomplete) {
                case 'Not Completed':
                  result = 'newCustomer';
                  break;
                case 'Completed':
                case 'Skipped':
                  result = 'existingCompleted';
                  break;
              }
              break;
            case 'Existing':
              switch (this.form.onboardingcomplete) {
                case 'Not Completed':
                  result = 'existingNotCompleted';
                  break;
                case 'Completed':
                case 'Skipped':
                  result = 'existingCompleted';
                  break;
              }
              break;
          }
        }

        return result;
      },
      showSaveButton() {
        /*
                * newCustomer
                * existingCompleted
                * existingNotCompleted
                * */
        let result = '';
        if (this.form) {
          switch (this.form.onboarding) {
            case 'New':
              switch (this.form.onboardingcomplete) {
                case 'Not Completed':
                  result = 'Save and Continue';
                  break;
                case 'Completed':
                case 'Skipped':
                  result = 'Update';
                  break;
              }
              break;
            case 'Existing':
              result = 'Update';
              break;
          }
        }

        if (this.regoOnborading) {
          result = 'Complete';
        }

        return result;
      },
      clubsSupported() {
        const clubsSupported = {};

        this.clubGroup.checkboxes.forEach(club => {
          clubsSupported[club.id] = club.isChecked;
        });

        return clubsSupported;
      },
      subscriptions() {
        const leagueSubscriptions = this.leagueGroupChecked.map(league => ({
          'ffa_name': league.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const otherSubscriptions = this.checkboxGroupChecked.map(checkbox => ({
          'ffa_name': checkbox.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const grassrootsSubscriptions = this.grassrootsGroupChecked.map(checkbox => ({
          'ffa_name': checkbox.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const resultArray = [
          ...grassrootsSubscriptions,
          ...leagueSubscriptions,
          ...otherSubscriptions
        ];

        if (this.priorityTicketingIsChecked) {
          resultArray.push({
            'ffa_name': this.priorityTicketingCheckbox.checkboxes[0].id,
            'statecode': 0,
            'ffa_membershipstatus': true
          });
        }

        return resultArray;
      },
      otherSettings() {
        const otherSettings = {};

        this.disableGroup.checkboxes.forEach(setting => {
          otherSettings[setting.id] = setting.isChecked;
        });

        otherSettings['ffa_unsubscribereason'] = this.disableGroup.checkboxes[0].reasoning[0].value;
        otherSettings['ffa_unsubscribereasonother'] = this.disableGroup.checkboxes[0].reasoning[1].value;

        return otherSettings;
      }
    },
    created() {
      if (!Object.keys(this.form).length) {
        this.isLoadingInitial = true;
        this.$store.dispatch('onboarding/GET_ONBOARDING_DATA').then(() => {
          this.isLoadingInitial = false;
          this.copyState();
        }).catch(errors => {
          this.errors = errors;

          if (errors instanceof Error) {
            // console.error(errors);
          }
        });
      } else {
        this.copyState();
      }
    },
    beforeDestroy() {
      if (this.destroyData) {
        this.$store.commit('onboarding/UPDATE_STATE', this.stateCopy);
      }
    },
    methods: {

      offersPath: function () {
        return this.$route.path === 'offers';
      },
      toggleInfoBox() {
        let boxStatus = false;
        this.clubGroup.checkboxes.forEach(club => {
          if (club.isChecked) boxStatus = true;
        });
        if (boxStatus) this.showInfoBox = true;
      },
      refreshWwcbidOptin() {
        let that = this;
        api.bangeo.getUser().then((response) => {
          if (!_.isEmpty(response.data.user)) {
            that.$store.commit('user/UPDATE_USER_DATA_ONLY', response.data.user);
            this.optinGroup.checkboxes[0].isChecked = !!response.data.user.wwcbid_optin;
            const payload = {
              groupName: 'optinGroup',
              checkboxIndex: 0,
              checkboxValue: this.optinGroup.checkboxes[0].isChecked
            };
            this.$store.commit('onboarding/SET_CHECKBOX_STATE', payload);
          }
        });
      },
      copyState() {
        this.stateCopy = cloneDeep(this.onboardingState);
      },
      checkboxClickHandler(groupName, checkboxIndex) {
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', {groupName, checkboxIndex});
        if (groupName == "clubGroup") this.toggleInfoBox();
      },
      saveOffers() {
        let formOffers = this.offerGroup.checkboxes;

        if (formOffers.length > 0) {
          let checkedOffers = [];

          formOffers.forEach(offer => {
            if (offer.cognito_id === null && offer.isChecked) {
              checkedOffers.push({
                offer_id: offer.id
              });
            }
          });

          if (checkedOffers.length > 0) {
            api.bangeo.saveUserOffers(checkedOffers).then(result => {
              this.redirectAfterSubmit();
            }).catch(error => {
              this.isLoading = false;
              this.errors = error;
              // console.log("saveUserOffers error", error);
            });
          } else {
            this.redirectAfterSubmit();
          }
        } else {
          this.redirectAfterSubmit();
        }
      },
      saveOptin() {
        if (this.optinGroup.checkboxes[0].isChecked !== this.user.wwcbid_optin && this.showWwcbidOptin) {
          this.user.wwcbid_optin = this.optinGroup.checkboxes[0].isChecked;
          this.$store.commit('user/UPDATE_USER_DATA_ONLY', this.user);
          api.bangeo.saveUser();
        }
      },
      redirectAfterSubmit() {
        this.isLoading = false;
        this.destroyData = false;

        let message = "Your preferences were successfully updated.";

        if (this.regoOnborading) {
          message = "Onboarding complete."
        }

        this.$router.push({
          name: 'myAccount',
          params: {
            message: {
              type: 'success',
              value: message
            }
          }
        });
      },
      onSubmit() {
        this.updateOnboardingData();
      },
      onCancel() {
        this.$store.commit('onboarding/UPDATE_STATE', this.stateCopy);
        this.$router.push({name: 'myAccount'});
      },
      updateOnboardingData() {

        // remove regoInprogress flag
        if (localStorage.regoInProgress) {
          localStorage.removeItem('regoInProgress');
        }

        const payload = {
          "clubs_supported": this.clubsSupported,
          "subscriptions": this.subscriptions,
          "ffa_donotbulkemail": this.disableCommunicationGroup.checkboxes[0].isChecked,
          // "remove_preferences": this.deletePreferences.checkboxes[0].isChecked,
          "ffa_donotbulkmobile": this.disableCommunicationGroup.checkboxes[1].isChecked,
          "ffa_unsubscribereason": (this.otherSettings.ffa_donotbulkemail) ? this.otherSettings.ffa_unsubscribereason : '',
          "ffa_unsubscribereasonother": (this.otherSettings.ffa_donotbulkemail) ? this.otherSettings.ffa_unsubscribereasonother : '',
          "ffa_bulkemailfrequency": (this.otherSettings.ffa_bulkemailfrequency) ? 'Break' : 'All',
          "ffa_preferenceonboardingcompleted": "Completed",
        };

        this.isLoading = true;
        if (!this.hasUsername) {
          if (this.showWwcbidOptin) {
            this.saveOptin();
          }
          this.saveOffers();
        } else {
          this.$store.dispatch('onboarding/UPDATE_ONBOARDING_DATA', payload)
              .then(() => {
                if (this.showWwcbidOptin) {
                  this.saveOptin();
                }
                // this.deletePreferences.checkboxes[0].isChecked = false
                this.saveOffers();
              })
              .catch(errors => {
                this.isLoading = false;
                this.errors = errors;
              });
        }
      },
      skipHandler() {
        this.isLoading = true;
        this.$store.dispatch('onboarding/SKIP_PREFERENCES_SELECTION')
            .then(() => {
              this.isLoading = true;
              this.$router.push({
                name: 'myAccount'
              });
            }).catch(err => {
          this.isLoading = false;
          this.skipErrors = err;
        });
      }
    }
  };
</script>
<style lang="scss">
	.tiles-form-group__container .tiles-form-group__item .is-checked .img-tile__inner {
    border: 3px solid #61a700;
  }
	.form-group-title {
    font-size: 26px;
    font-weight: 600%;
    color: #000;
    margin: 13px 0 37px;
  }
	.email-com-infobox {
    margin-top: -35px;
    margin-bottom: 30px;
    text-align: left;
    padding: 10px 20px 10px 20px;

    h2 {
      font-weight: 600;
      font-size: 16px;
      line-height: 18px;
      position: relative;
      padding-bottom: 5px;
    }

    p {
      margin-bottom: 10px;
    }
  }

	@media (max-width: 660px) {
    .email-com-infobox {
      margin-top: -10px;
    }
  }

	@media (min-width: 200px) {
    .form-group-title {
      font-size: 20px;
      font-weight: 600%;
      color: #000;
      margin: 13px 0 37px;
      line-height: 1.3;
    }
  }

	@media (min-width: 400px) {
    .form-group-title {
      font-size: 26px;
      font-weight: 600%;
      color: #000;
      margin: 13px 0 37px;
      line-height: 1.54;
    }
  }

</style>
